const Systems ="wow789" 

export default Systems;
